import { PictureComponent } from "./components/picture/picture.component";
import { ButtonComponent } from "./components/button/button.component";
import { BGButtonComponent } from "./components/bg-button/bg-button.component";
import { IframeComponent } from "./components/iframe/iframe.component";
import { AbstractPageComponent } from "./components/abstract-page/abstract-page.component";
import { ClickOutsideDirective } from "./directive/click-outside.directive";
import { specificComponents } from "./shared-specific-component";
import { HeadingComponent } from "./components/heading/heading.component";
import { AutosuggestInputComponent } from "./components/autosuggest-input/autosuggest-input.component";
import { ModalComponent } from "./components/modal/modal.component";
import { ModalVideoComponent } from "./components/modal-video/modal-video.component";
import { BGModalVideoComponent } from "./components/bg-modal-video/bg-modal-video.component";
import { SafePipe } from "./pipes/safe.pipe";
var components = [
    PictureComponent,
    IframeComponent,
    ButtonComponent,
    BGButtonComponent,
    AbstractPageComponent
].concat(specificComponents, [
    ClickOutsideDirective,
    HeadingComponent,
    AutosuggestInputComponent,
    ModalComponent,
    ModalVideoComponent,
    BGModalVideoComponent,
    SafePipe,
]);
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    return SharedModule;
}());
export { SharedModule };
